<template>
  <div id="ClockRecordFilter">
    <!-- 即將抵達訪客列表 訪客登記區塊 -->
    <div class="checkInWrap">
      <filter-frame
        ref="filter"
        :filter-form="depositFilter"
        @search="search"
        @clear="search"
      />
    </div>
  </div>
</template>
<script>
import filterFrame from '@/components/FilterFrame'

export default {
  components: {
    filterFrame
  },
  props: {
    search: {
      type: Function
    }
  },
  data () {
    return {
      depositFilter: [
        {
          label: '姓名',
          name: 'name',
          type: 'input'
        },
        {
          label: '上班時間', // 這是對的嗎 哈哈
          name: 'date',
          type: 'date'
        },
        {
          label: '',
          name: 'status',
          type: 'checkbox',
          options: ['未打卡上班', '未打卡下班']
        }
      ],
      loading: false
    }
  },
  mounted () {
    this.filterActive()
  },
  methods: {
    filterActive () {
      this.$refs.filter.onSearch()
    }
  }
}

</script>
<style lang="sass" scoped>

</style>
